/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetLocationModifierGroups200ResponseItemsInner } from './GetLocationModifierGroups200ResponseItemsInner';
import {
    GetLocationModifierGroups200ResponseItemsInnerFromJSON,
    GetLocationModifierGroups200ResponseItemsInnerFromJSONTyped,
    GetLocationModifierGroups200ResponseItemsInnerToJSON,
    GetLocationModifierGroups200ResponseItemsInnerToJSONTyped,
} from './GetLocationModifierGroups200ResponseItemsInner';

/**
 * 
 * @export
 * @interface GetLocationModifierGroups200Response
 */
export interface GetLocationModifierGroups200Response {
    /**
     * 
     * @type {Array<GetLocationModifierGroups200ResponseItemsInner>}
     * @memberof GetLocationModifierGroups200Response
     */
    items: Array<GetLocationModifierGroups200ResponseItemsInner>;
    /**
     * 
     * @type {number}
     * @memberof GetLocationModifierGroups200Response
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof GetLocationModifierGroups200Response
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof GetLocationModifierGroups200Response
     */
    itemsPerPage: number;
}

/**
 * Check if a given object implements the GetLocationModifierGroups200Response interface.
 */
export function instanceOfGetLocationModifierGroups200Response(value: object): value is GetLocationModifierGroups200Response {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('itemsPerPage' in value) || value['itemsPerPage'] === undefined) return false;
    return true;
}

export function GetLocationModifierGroups200ResponseFromJSON(json: any): GetLocationModifierGroups200Response {
    return GetLocationModifierGroups200ResponseFromJSONTyped(json, false);
}

export function GetLocationModifierGroups200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLocationModifierGroups200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(GetLocationModifierGroups200ResponseItemsInnerFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'itemsPerPage': json['itemsPerPage'],
    };
}

export function GetLocationModifierGroups200ResponseToJSON(json: any): GetLocationModifierGroups200Response {
    return GetLocationModifierGroups200ResponseToJSONTyped(json, false);
}

export function GetLocationModifierGroups200ResponseToJSONTyped(value?: GetLocationModifierGroups200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(GetLocationModifierGroups200ResponseItemsInnerToJSON)),
        'total': value['total'],
        'page': value['page'],
        'itemsPerPage': value['itemsPerPage'],
    };
}

